// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"0517b5c663986d3c","5285":"fc447add406b9e4f"}[chunkId] + ".css";
};